export enum WorkflowFunctionTypeOptions {
    RappiderServices = 'rappider-service',
    WorkflowFunctions = 'workflow-function'
}
